import React from 'react'
import {Routes, Route, Link} from 'react-router-dom';

export default function Card (props){

    const workTitle = props.work.type == "record" ? `"${props.work.title}"` :<i>{props.work.title}</i>

    const producer = props.work.producer ? (
        <div>Producer(s): {props.work.producer}</div>
    ) : null;

    const producerR = props.work.producerR ? (
        <>Producer. </>
    ) : null;

    const recEng = props.work.recEng ? (
        <div>Recording Engineer: {props.work.recEng}</div>
    ) : null;

    const recEngR = props.work.recEngR ? (
        <>Recording Engineer. </>
    ) : null;

    const mixEng = props.work.mixEng ? (
        <div>Mixing Engineer: {props.work.recEng}</div>
    ) : null;

    const mixEngR = props.work.mixEngR ? (
        <>Mix Engineer. </>
    ) : null;

    const execProd = props.work.mixEng ? (
        <div>Executive Producer: {props.work.execProd}</div>
    ) : null;

    const execProdR = props.work.execProdR ? (
        <>Executive Producer. </>
    ) : null;

    const awards = props.work.awards ? (
        <div>{props.work.awards}</div>
    ) : null;

    return (
        <div className="workCard col">
            <div className="row">
                <Link 
                    to={"/single-work"}
                    state= {{
                        work: props.work
                    }}
                >
                    <img id="cardImg" src={props.work.artSm} />
                </Link>
                
            </div>
            <div id="cardTitle" className="row">{workTitle}</div>
            <div id="cardArtist" className="row">{props.work.artist}</div>
            {/* {producer}
            {awards} */}
            <div id="cardRoles" className="row">Role - {producerR}{recEngR}{mixEngR}{execProdR}</div>
        </div>
    )
}